$(document).ready(function() {
	Shopify.queryParams = {};
	if (location.search.length) {
		for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
			aKeyValue = aCouples[i].split('=');
			if (aKeyValue.length > 1) {
				Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
			}
		}
	}


	//sort dropdown toggle
	$(".sort-by-buttons").css("display", "none");
	$("#sort-by-toggle").click(function(event){
		event.preventDefault();
		$(".sort-by-container").toggleClass("opened");
		$(".sort-by-buttons").toggle();
		$("#sort-by-toggle").toggleClass("opened");
		$("#sort-by-toggle svg").toggleClass('arrow-flip');
	});

	//filter menu toggles
	$(".filter-menu-container button.close").click(function(){
		$(".filters-container").toggleClass('filter-toggle');
		$("#refine-toggle").toggleClass("opened");
		$("#refine-toggle svg").toggleClass('arrow-flip');
		$(".filter-menu-container").toggleClass("filters-opened");
	});

	$("#refine-toggle").click(function(){
		$("#refine-toggle").toggleClass("opened");
		$("#refine-toggle svg").toggleClass('arrow-flip');
		$(".filter-menu-container").toggleClass("filters-opened");
	});
});
